import React from 'react'
import TableHeader from './TableHeader'
import TableBody from './TableBody'
import styled from 'styled-components'

interface TableProps {
  columns: any[]
  sortColumn: any
  onSort?: (column: any) => void
  data: any[]
  checkBox: boolean
  setSelectedRows: (rows: any[]) => void
  selectedRows: any[]
  tableRef: React.RefObject<HTMLTableElement>
  loading: boolean
  handleSelectAll: (selected: boolean) => void
  handleRowClick: (row: any) => void
  responsive?: boolean
  contentLoading?: boolean
  formListings?: boolean
  type?: string
  maxHeight?: string
}

const Table = ({
  columns,
  sortColumn,
  onSort,
  data,
  checkBox,
  setSelectedRows,
  selectedRows,
  tableRef,
  loading,
  handleSelectAll,
  handleRowClick,
  responsive = true,
  contentLoading = false,
  formListings = false,
  type = '',
  maxHeight,
}: TableProps) => {
  return (  
    <StyledTableContainer
      className={`w-100 ${responsive && 'table-responsive'}`}
      style={{maxHeight: maxHeight ? maxHeight : '700px', overflowY: 'auto'}}
    >
      <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 table-hover mb-0'>
        <TableHeader
          columns={columns}
          data={data}
          handleSelectAll={handleSelectAll}
          checkBox={checkBox}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          sortColumn={sortColumn}
          formListings={formListings}
          type={type}
        />
        <TableBody
          columns={columns}
          checkBox={checkBox}
          handleRowClick={handleRowClick}
          data={data}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          loading={loading}
          contentLoading={contentLoading}
        />
      </table>
    </StyledTableContainer>
  )
}

export default Table

const StyledTableContainer = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: auto;
  padding: 0px;
  border-radius: 5px;

  /* Responsive scrollbar */
  ::-webkit-scrollbar {
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
  }
`
